export default {"src":"/statics/ecommerce/_next/static/media/logo_BIG.6aade89e.svg","height":132,"width":286,"blurWidth":0,"blurHeight":0};